module.exports = __webpack_public_path__ + "assets/img/8icon.df74f712.png";